import { h } from "preact";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import IconArrowRightLargeShadow from "utils/icon/icon-arrow-right-large-shadow.svg";
import Image from "utils/image";
import { useState, useEffect } from "preact/hooks";
import debounce from "utils/debounce";

const breakpoints = {
  320: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 3.5,
  },
};

const SampleCard = ({
  product,
  cart,
  enableFreeSamples,
  isThresholdFull,
  showErrorOnThreshold,
  setShowError,
  isAdding,
  isLoading,
}) => {
  const { state } = cart;
  const { item_count, items } = state;
  const currentProduct = product.variantBySelectedOptions;

  const [isProduct, setIsProduct] = useState(null);

  useEffect(() => {
    setIsProduct(false);
    if (item_count > 0) {
      items.forEach((item) => {
        if (currentProduct.id.includes(item.id)) {
          setIsProduct(true);
        }
      });
    }
  }, [cart]);

  const handleAddToCart = (e) => {
    e.preventDefault();
    isAdding(true);
    const addToCartEvent = new CustomEvent("cart:add", {
      detail: {
        payload: {
          merchandiseId: `${product.variantBySelectedOptions.id}`,
          quantity: 1,
        },
      },
    });
    document.dispatchEvent(addToCartEvent);
    setTimeout(() => {
      isAdding(false);
    }, 2000);
  };

  return (
    <div className="h-full flex justify-between flex-col">
      <div>
        {product.images[0] && (
          <div className="h-[136px] mb-2.5 [&_img]:w-auto [&_img]:h-auto [&_img]:max-w-full [&_img]:max-h-full overflow-hidden">
            <Image
              classes="object-cover"
              {...product.images[0]}
              srcWidths={{ sm: 640 }}
            />
          </div>
        )}
        {!!product.title && (
          <div
            className="mb-2.5 body-xs text-grey-2A text-center"
            dangerouslySetInnerHTML={{ __html: product.title }}
          ></div>
        )}
      </div>
      <div>
        <button
          className={`${
            item_count == 0 ? "text-grey-5C border-grey-B4 disabled" : ""
          } button h-10 w-full pl-1 pr-1 mb-1 ${
            isProduct ? "button-primary !bg-supergoop-blue" : "button-secondary"
          }`}
          disabled={
            isLoading || isProduct || !enableFreeSamples || !currentProduct.availableForSale
          }
          onClick={(e) =>
            showErrorOnThreshold && !isThresholdFull
              ? setShowError(true)
              : handleAddToCart(e)
          }
        >
          {!currentProduct.availableForSale
            ? window.TMW.Strings.cart.soldOut
            : isProduct
            ? window.TMW.Strings.cart.addedSample
            : window.TMW.Strings.cart.addSample}
        </button>
      </div>
    </div>
  );
};

const CartSamples = ({
  freeSamples,
  cart,
  wrapperClass,
  enableFreeSamples,
  isThresholdFull,
  showErrorOnThreshold = false,
  errorMessage = "",
}) => {
  const { textEmpty, text, cartPage, products } = freeSamples;
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    debounce(() => {
      setShowError(false);
    }, 3000)();
  }, [showError]);

  const handleAddToCart = (value) => {
    setIsLoading(value);
  }

  return (
    <div className={`${wrapperClass ? wrapperClass : "p-5 relative w-full"}`}>
      <div className="sub-h7 mb-3 text-grey-2A">
        {cart?.state?.item_count == 0 ? textEmpty : text}
      </div>
      <div className={`relative ${cartPage ? "mb-5" : ""}`}>
        <div className="swiper-sample-prev absolute text-white hover:text-supergoop-yellow rotate-180 z-10 top-8 left-0 cursor-pointer">
          <IconArrowRightLargeShadow />
        </div>

        <div className="swiper-sample-next absolute text-white hover:text-supergoop-yellow z-10 top-8 right-0 cursor-pointer">
          <IconArrowRightLargeShadow />
        </div>
        <Swiper
          modules={[Navigation]}
          slidesPerView={4}
          allowTouchMove={true}
          spaceBetween={8}
          loop={false}
          breakpoints={breakpoints}
          navigation={{
            prevEl: ".swiper-sample-prev",
            nextEl: ".swiper-sample-next",
            disabledClass: "hidden",
          }}
        >
          {products?.map(
            (product, index) =>
              product.variantBySelectedOptions && (
                <SwiperSlide
                  className="h-auto"
                  key={`freeSamples-${index}
              `}
                >
                  <SampleCard
                    setShowError={setShowError}
                    product={product}
                    cart={cart}
                    isAdding={(e) => handleAddToCart(e)}
                    isLoading={isLoading}
                    isThresholdFull={isThresholdFull}
                    showErrorOnThreshold={showErrorOnThreshold}
                    enableFreeSamples={enableFreeSamples}
                  />
                </SwiperSlide>
              )
          )}
        </Swiper>
        {showError && errorMessage && (
          <p
            class="py-2 text-error body-xs mt-2 flex items-center justify-center align-center border-error border"
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          ></p>
        )}
      </div>
    </div>
  );
};
export default CartSamples;
